import {Component, Vue} from "vue-property-decorator";
import {_CONST} from "@/constants/constants";

@Component
export default class ConstantMixin extends Vue {
  get _CONST(): any {
    return _CONST;
  }

}
